import axios from 'axios';

// CloudFront routes the public API under /api. Keep this same-origin so a
// developer shell variable can never send the deployed AWS app back to Heroku.
export const API_BASE_URL = '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const apiError = (error, fallback = 'Something went wrong.') =>
  error?.response?.data?.error || fallback;

export default api;
